import { UrlRewritePipe } from '@teamfoster/sdk/text-utility';
import { ContentBlock, ContentBlockListInfo } from '../models';
import { inject } from '@angular/core';
import { title } from 'process';

const rewrite = new UrlRewritePipe();

// for every block that has the same type as the previous block
// than for every consecutive block set boolean to true alternating
export function getConsecutiveBlockTypes(arr: ContentBlock[]): ContentBlockListInfo[] {
  const result: ContentBlockListInfo[] = [];

  if (arr.length === 0) {
    return result;
  }

  let consecutiveAlternating = false;
  let prevBlock = arr[0];

  for (let i = 0; i < arr.length; i++) {
    const currentBlockType = arr[i].blockType;

    // If prev block is forced to be reversed via CMS, set flag to true, so alternating picks up after the manually reversed block
    consecutiveAlternating = prevBlock.reversedOrder || consecutiveAlternating;

    if (i !== 0 && currentBlockType === prevBlock.blockType) {
      consecutiveAlternating = !consecutiveAlternating; // Toggle consecutive flag
    } else {
      consecutiveAlternating = false; // Reset consecutive flag if blocktype changes
    }

    // If currrent block is forced to be reversed via CMS, set flag to true
    consecutiveAlternating = arr[i].reversedOrder ? !consecutiveAlternating : consecutiveAlternating;

    // check if there are multiple blocks with the same title used for anchor navigation
    const titlesWithIndex = arr.map((cur, index, res) => {
      const occurrences = res.slice(0, index).filter(x => x.title === cur.title).length + 1;
      return (occurrences > 1 ? `${cur.title} ${occurrences}` : cur.title) || 'sectie-' + cur.id;
    });

    result.push({
      blockType: currentBlockType,
      blockIndex: i,
      alternate: consecutiveAlternating,
      consecutive: i !== 0 && currentBlockType === prevBlock.blockType,
      anchor: rewrite.transform(titlesWithIndex[i]),
      anchorTitle: arr[i].menuTitle,
      blockTypeTitle: arr[i].cmsblockTypeTitle,
      // anchor: rewrite.transform(arr[i].title) + (hasSameTitle ? '-' + arr[i].id : ''),
    });

    prevBlock = arr[i];
  }

  return result;
}
